'use strict';

var React = require('react');

var SvgDraftOrdersMajor = function SvgDraftOrdersMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m19.101 3.291-2.392-2.393.398-.398a1.692 1.692 0 1 1 2.393 2.392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.61 1.994 2.393 2.393-6.503 6.503-3.168.777.776-3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3v11h3.5c.775 0 1.388.662 1.926 1.244l.026.028.085.091c.365.392.885.637 1.463.637.578 0 1.098-.245 1.463-.637a31 31 0 0 0 .102-.11l.009-.009c.538-.581 1.151-1.244 1.926-1.244h3.5v-3a1 1 0 1 1 2 0v6.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h6.5a1 1 0 1 1 0 2z"
  }));
};

exports.SvgDraftOrdersMajor = SvgDraftOrdersMajor;
